export const adverseEventDmeSearchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance',
    'displayedColumns': 'default',
    'direction': 'asc'
  },
  {
    'value': '^root_dmeReactions',
    'display': 'Dme Reactions, Ascending',
    'displayedColumns': 'dmeReactions',
    'direction': 'asc'
  },
  {
    'value': '$root_dmeReactions',
    'display': 'Dme Reactions, Descending',
    'displayedColumns': 'dmeReactions',
    'direction': 'desc'
  },
  {
    'value': '^root_ptTermMeddra',
    'display': 'PT Term Meddra, Ascending',
    'displayedColumns': 'ptTermMeddra',
    'direction': 'asc'
  },
  {
    'value': '$root_ptTermMeddra',
    'display': 'PT Term Meddra, Descending',
    'displayedColumns': 'ptTermMeddra',
    'direction': 'desc'
  },
  {
    'value': '^root_caseCount',
    'display': 'Case Count, Ascending',
    'displayedColumns': 'caseCount',
    'direction': 'asc'
  },
  {
    'value': '$root_caseCount',
    'display': 'Case Count, Descending',
    'displayedColumns': 'caseCount',
    'direction': 'desc'
  },
  {
    'value': '^root_dmeCount',
    'display': 'Dme Count, Ascending',
    'displayedColumns': 'dmeCount',
    'direction': 'asc'
  },
  {
    'value': '$root_dmeCount',
    'display': 'Dme Count, Descending',
    'displayedColumns': 'dmeCount',
    'direction': 'desc'
  },
  {
    'value': '$root_dmeCountPercent',
    'display': 'Dme Count Percent, Descending',
    'displayedColumns': 'dmeCountPercent',
    'direction': 'desc'
  },
  {
    'value': '^root_dmeCountPercent',
    'display': 'Dme Count Percent, Ascending',
    'displayedColumns': 'dmeCountPercent',
    'direction': 'asc'
  },
  {
    'value': '^root_weightedAvgPrr',
    'display': 'Weighted Avg Prr, Ascending',
    'displayedColumns': 'weightedAvgPrr',
    'direction': 'asc'
  },
  {
    'value': '$root_weightedAvgPrr',
    'display': 'Weighted Avg Prr, Descending',
    'displayedColumns': 'weightedAvgPrr',
    'direction': 'desc'
  },
  {
    'value': '^root_name',
    'display': 'Ingredient, Ascending',
    'displayedColumns': 'ingredientName',
    'direction': 'asc'
  },
  {
    'value': '$root_name',
    'display': 'Ingredient Name, Descending',
    'displayedColumns': 'ingredientName',
    'direction': 'desc'
  }
];
